/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { RouteComponentProps } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import { Text } from 'hocs/localization'
import { isInventoryForChangePlanAvailable, isPlanAvailable } from 'redux-app/utils/subscription'
import ProfileContent from 'apps/ProfileContent'
import ButtonWithIcon from 'apps/ButtonWithIcon'
import PlanItem from 'routes/Main/apps/SelectPlan/apps/PlanItem'
import MultiPlanItem from 'routes/Main/apps/SelectPlan/apps/MultiPlanItem/MultiPlanItem'
import { toCurrency } from 'utils/price'
import * as styles from './PlanChoice.scss'

const cx = classNames.bind(styles)

interface IProps extends RouteComponentProps {
  t: Text
  isUserLogin: boolean,
  handleSubmit: any,
  acceptTerms: () => void,
  plans: any[],
  groupedPlans: any[][],
  activePlanId: string,
  onChangePlan: (planId: string) => Promise<{}>,
  onShowTerms: (planId: string) => Promise<{}>,
}

interface IState {
  selectedPlanId: string,
  isUserAbleToOpenProfile: boolean,
  isButtonDisabled: boolean,
  isSubmitting: boolean,
  plansState: any[],
  groupedPlansState: any[][],
}

class PlanChoice extends React.Component<IProps, IState> {
  public state = {
    selectedPlanId: this.props.activePlanId,
    isButtonDisabled: true,
    isSubmitting: false,
    plansState: this.props.plans,
    groupedPlansState: this.props.groupedPlans,
  }

  private onChangeCheckBoxState = (weight) => {

    const plansFromState = [...this.state.plansState]
    const plansFromGroup = plansFromState.filter(x => x.weight === weight)

    // exchange plans vivibility
    const firstGroupPlanVisibility = plansFromGroup[0].visible
    plansFromGroup[0].visible = plansFromGroup[1].visible
    plansFromGroup[1].visible = firstGroupPlanVisibility

    this.setState({ plansState: plansFromState })
  }

  private onChoosePlan = planId => {
    const selectedPlanId = planId
    this.setState({
      isSubmitting: true,
    })
    const newPlan = this.props.plans.find(plan => plan.id === selectedPlanId)

    if (!isInventoryForChangePlanAvailable(newPlan)) {
      this.props.selectPlan(newPlan.id)
      this.props.history.push(ROUTES.profile.changePlan.noAvailablePrinter)
      return
    }
    if (this.props.isUserAbleToOpenProfile) {
      return this.props.onShowTerms(selectedPlanId)
    }
    this.props.onChangePlan(selectedPlanId)
      .catch(() => {
        this.setState({
          isSubmitting: false,
        })
      })
  }

  private onReturnBack = () => {
    this.props.history.push(ROUTES.profile.view)
  }

  public render () {
    const {
      t,
      isUserLogin,
    } = this.props
    const {
      plansState,
      groupedPlansState,
    } = this.state

    return (
      <ProfileContent>
        <div className='row'>
          <div className={cx('col-md-12', 'text-center')}>
            <div className={styles.title}>
              <h2>{t('title')}</h2>
            </div>
          </div>
        </div>
        <div className={cx('row', styles.topSpace50)}>

        {Object.keys(groupedPlansState).map((key) => {

          var planItem : any;
          var planItem2 : any;

          if (groupedPlansState[key].length > 0) {
            planItem = plansState.find(x => x.id === groupedPlansState[key][0].id);
          }

          if (groupedPlansState[key].length > 1) {
            planItem2 = plansState.find(x => x.id === groupedPlansState[key][1].id);
          }

          return (
            <div
              key={groupedPlansState[key][0].id}
              className={cx('col-lg-3', 'col-md-6', 'col-sm-12', 'plan', styles.plan)}
            >
              {groupedPlansState[key].length === 1 && (
                <PlanItem
                  key={groupedPlansState[key][0].id}
                  plan={planItem}                  
                  onSelectSubscriptionPlan={this.onChoosePlan} t={t} isAccessibleToUser={!isUserLogin}
                  isSelectable={planItem.hasInventoryForChangePlan}
                />
              )}
              {groupedPlansState[key].length > 1 && (
                <MultiPlanItem
                  plan={planItem}
                  plan2={planItem2}
                  onChangeCheckBox={this.onChangeCheckBoxState}
                  onSelectSubscriptionPlan={this.onChoosePlan} t={t} isAccessibleToUser={!isUserLogin}
                  isSelectable={planItem.hasInventoryForChangePlan}
                  isSelectable2={planItem2.hasInventoryForChangePlan}
                />
              )}
            </div>
          )},
          )}

          <div className={cx(styles.saveChange, styles.topSpace50)}>
            <div className={styles.backLink}>
              <ButtonWithIcon
                styleType='noStyle'
                iconName='arrowLeft'
                onClick={this.onReturnBack}
              >
                {t('back')}
              </ButtonWithIcon>
            </div>
          </div>
        </div>
      </ProfileContent>
    )
  }
}

export default PlanChoice
